// Module
var code = "<text-editor id=\"{{ componentId }}\" class=\"editor form-control\" ng-model=\"data[component.key]\" ng-disabled=\"readOnly || component.disabled\" ng-model-options=\"{ allowInvalid: true }\" ng-required=\"isRequired(component)\" ng-attr-name=\"{{ componentId || component.key }}\" ng-change=\"changeValue()\"></text-editor> ";
// Exports
export default code;